import { TimeGroup, timeGroups } from "@ots-frontend/ots-data";
import { BaseDbCodeSelect, DbCodeSelectProps } from "../base-db-code-select";

type Props = DbCodeSelectProps<TimeGroup>;

export const TimeGroupSelect = (props: Props) => {
  const { options = timeGroups, ...rest } = props;
  return <BaseDbCodeSelect options={options} {...rest} />;
};
